import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

interface UnusedObjectsHeaderProps {
  onRefresh: () => void;
  refreshing: boolean;
}

const UnusedObjectsHeader: React.FC<UnusedObjectsHeaderProps> = ({
  onRefresh,
  refreshing,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 3,
      }}
    >
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
          Unused SQL Objects
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Monitor and review database objects that haven&apos;t been used
          recently
        </Typography>
      </Box>
      <IconButton
        onClick={onRefresh}
        disabled={refreshing}
        sx={{
          bgcolor: "primary.main",
          color: "white",
          "&:hover": { bgcolor: "primary.dark" },
          "&:disabled": { bgcolor: "grey.300" },
        }}
      >
        <RefreshIcon
          sx={{
            animation: refreshing ? "spin 1s linear infinite" : "none",
            "@keyframes spin": {
              "0%": { transform: "rotate(0deg)" },
              "100%": { transform: "rotate(360deg)" },
            },
          }}
        />
      </IconButton>
    </Box>
  );
};

export default UnusedObjectsHeader;
